import { Box, Typography } from "@mui/material";
import React from "react";
import CustomButton from "../../../global/components/CustomButton/CustomButton";
import AttendanceStyles from "./AttendanceStatusBox.style";

interface AttendanceStatusBoxProps {
  boxHeading: string;
  data: any;
  icon: string;
  slash?: any
}
const AttendanceStatusBox = (props: any) => {
  const classes = AttendanceStyles;
  return (
    <Box sx={classes.statusBox}>
      <Box sx={classes.boxStyle}>
        <Box>{<img src={props.icon} />}</Box>
        <Box display={"flex"} gap={"10px"} flexDirection={"column"}>
          <Typography sx={classes.textMargin}>{props.boxHeading}</Typography>
          <Box display={"flex"} alignItems={"baseline"}>
            <Typography sx={classes.available}>{props.available}</Typography>{" "}
            <Typography sx={{marginLeft : "5px"}}>{props.slash}</Typography> {/* Add slash here */}
            <Typography sx={classes.total}>{props.total}</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AttendanceStatusBox;
